// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F6Zl","label":"styles_label__zA36f"};